import { render } from "./userNote.vue?vue&type=template&id=2ee6c4d1&scoped=true"
import script from "./userNote.vue?vue&type=script&lang=js"
export * from "./userNote.vue?vue&type=script&lang=js"

import "./userNote.vue?vue&type=style&index=0&id=2ee6c4d1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee6c4d1"],['__file',"src/components/offersDetails/userNote.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ee6c4d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ee6c4d1', __exports__)) {
    api.reload('2ee6c4d1', __exports__)
  }
  
  module.hot.accept("./userNote.vue?vue&type=template&id=2ee6c4d1&scoped=true", () => {
    api.rerender('2ee6c4d1', render)
  })

}


export default __exports__